import { AnyObject } from 'final-form';
import UniqueId from 'src/util/UniqueId';
import { IRootState } from 'src/reducers';
// import actions from 'src/actions';

import { actionCreators as navigationActions } from 'src/reducers/Navigation';
import { Dispatch, Store } from 'redux';

class SecondWindowService {
    static instace: SecondWindowService;
    uid: string;
    recChannel: BroadcastChannel;
    dispatch: Dispatch;

    private constructor() {}

    static getInstance() {
        if (!SecondWindowService.instace) {
            SecondWindowService.instace = new SecondWindowService();
        }
        return SecondWindowService.instace;
    }

    initialize = (store: Store<IRootState>) => {
        this.uid = UniqueId.Create();
        this.dispatch = store.dispatch;
    };

    subscribe = () => {
        this.recChannel = new BroadcastChannel('test');

        this.recChannel.onmessage = (e: MessageEvent) => {
            console.log(e.data);
            if (e.data.sender !== this.uid) {
                this.handleMessage(e.data.messageType, e.data.payload);
            }
        };
    };

    tearDown = () => {
        this.uid = undefined;
    };

    handleMessage = (messageType: string, payload: AnyObject) => {
        console.log(messageType, payload);
        switch (messageType) {
            case 'navigate':
                this.dispatch(navigationActions.navigate({ path: '/' }));
                this.dispatch(
                    navigationActions.navigate({
                        path: `${payload.payload.path}${payload.payload.search ? payload.payload.search : ''}${
                            payload.payload.search ? '&' : '?'
                        }sw=true`,
                    })
                );
                break;
            case 'pushform':
                this.dispatch(navigationActions.updateForm(payload));
                break;
            default:
                console.log('unknown message recvd');
        }
    };

    sendMessage = (target: string, messageType: string, payload: AnyObject | string) => {
        // console.log('sm', payload);
        const message: AnyObject = {
            messageType,
            payload,
            sender: this.uid,
        };
        // console.log('message', message);
        if (this.recChannel) {
            this.recChannel.postMessage(message);
        }
    };
}

const secondWindowService = SecondWindowService.getInstance();
export default secondWindowService;



// WEBPACK FOOTER //
// ./src/service/SecondWindowService.ts